import { Config } from '@/config';
import { ApiService } from '@/services/api.service';
import axios from 'axios';

const CancelToken = axios.CancelToken;
// Only a newer list request cancels the list request: a write is never cancelled, the server may already have applied it
let cancelTokens = {
  documentKeywordCategories: null,
};

class DocumentKeywordsService {
  getKeywords() {
    if (cancelTokens.documentKeywordCategories) cancelTokens.documentKeywordCategories.cancel('Multiple requests.');
    cancelTokens.documentKeywordCategories = CancelToken.source();

    return ApiService.get(`${Config.api.document.url}api/v1/document-keyword-categories/`, {
      cancelToken: cancelTokens.documentKeywordCategories.token,
    }).then((response) => response.data);
  }

  addKeywordsBulk(categoryId, keywords) {
    return ApiService.post(
      `${Config.api.document.url}api/v1/document-keyword-categories/${categoryId}/keywords/bulk`,
      keywords,
    ).then((response) => response.data);
  }

  updateKeyword(categoryId, keywordId, updatedKeyword) {
    const data = {
      value: updatedKeyword,
    };
    return ApiService.put(
      `${Config.api.document.url}api/v1/document-keyword-categories/${categoryId}/keywords/${keywordId}`,
      data,
    ).then((response) => response.data);
  }
  deleteDocumentKeywordsBulk(categoryId, ids) {
    return ApiService.delete(`${Config.api.document.url}api/v1/document-keyword-categories/${categoryId}/keywords`, {
      data: ids,
    }).then((response) => response.data);
  }

  addCategory(language, name, colorCode) {
    const categoryData = {
      language,
      name,
      colorCode,
    };

    return ApiService.post(`${Config.api.document.url}api/v1/document-keyword-categories/`, categoryData)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  }
  deleteCategory(categoryId) {
    return ApiService.delete(`${Config.api.document.url}api/v1/document-keyword-categories/${categoryId}`).then(
      (response) => response.data,
    );
  }
  updateCategory(categoryId, { name, colorCode }) {
    const data = {
      name,
      colorCode,
    };
    return ApiService.put(`${Config.api.document.url}api/v1/document-keyword-categories/${categoryId}`, data).then(
      (response) => response.data,
    );
  }
}

export const documentKeywordsService = new DocumentKeywordsService();
